import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@legacy/components/mui-components';

interface SettingsContentWrapperProps {
  header: string;
  description?: string;
  children?: ReactNode;
}

export const SettingsContentWrapper = ({
  header,
  description,
  children,
}: SettingsContentWrapperProps) => (
  <Box sx={{ py: 4, pr: 6, pl: 4 }}>
    <Stack gap={3}>
      <Stack>
        <Typography variant="h2" component="h1">
          {header}
        </Typography>
        {description && (
          <Typography component="p" variant="h4">
            {description}
          </Typography>
        )}
      </Stack>
      {children}
    </Stack>
  </Box>
);
